import React from "react";
import AlertIcon from './alertIcon';

export default function ModalMessage({ open, setOpen, type, message, callbackClosed }) {
  const close = () => {
    setOpen(false);
    if (callbackClosed && type === 'success') {
      callbackClosed();
    }
  };

  return (
    <div className="modalMessage">
      <div className={`modal${open ? ' open' : ''}`}>
        <button className="close" onClick={() => close()}></button>
        <div className="modal-content">
          <div className="icon">
            <AlertIcon type={type} />
          </div>
          <p className="message">{message}</p>
        </div>
      </div>
      <div className={`modal-overlay${open ? ' open' : ''}`} onClick={() => close()}></div>
    </div>
  );
}